<template>
  <div class="tournaments-page">
    <div class="page-head">
      <div class="left">
        <h1>Manage tournaments</h1>
      </div>
    </div>
    <TournamentsList ref="TournamentsList" />
  </div>
</template>

<script>
import TournamentsList from "@/components/Tournaments/TournamentsList";

export default {
  name:"Tournaments",
  components: {
    TournamentsList,
  },
  methods: {
    handleAddNew() {
      this.$refs.TournamentForm.triggerModal();
    }
  }
};
</script>
